'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioLabelStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  checked: false,
  disabled: false
};
/** PROP RECEIVERS */

var inputBase = function inputBase(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.radio.input,
      size = _theme$reactackle$com.size,
      borderWidth = _theme$reactackle$com.borderWidth,
      borderRadius = _theme$reactackle$com.borderRadius;
  var _theme$reactackle$com2 = theme.reactackle.components.radio.label,
      fontSize = _theme$reactackle$com2.fontSize,
      lineHeight = _theme$reactackle$com2.lineHeight;
  var borderWdth = (0, _reactackleCore.getValueString)(borderWidth),
      sizeString = (0, _reactackleCore.getValueString)(size),
      top = 'calc(' + lineHeight / 2 + 'em - ' + sizeString + ' / 2 - ' + borderWdth + ')';
  return '\n    top: ' + top + ';\n    width: ' + sizeString + ';\n    height: ' + sizeString + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    border-width: ' + borderWdth + ';\n    border-style: solid;\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n  ';
};

var labelBase = function labelBase(_ref2) {
  var themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var size = (0, _reactackleCore.getValueString)(theme.reactackle.components.radio.input.size);
  var _theme$reactackle$com3 = theme.reactackle.components.radio.label,
      inputLabelSpacing = _theme$reactackle$com3.inputLabelSpacing,
      fontSize = _theme$reactackle$com3.fontSize,
      lineHeight = _theme$reactackle$com3.lineHeight;
  return '\n    padding-left: calc(' + size + ' + ' + (0, _reactackleCore.getValueString)(inputLabelSpacing) + ');\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    min-width: ' + size + ';\n    min-height: ' + size + ';\n  ';
};

var labelStateProps = function labelStateProps(_ref3) {
  var checked = _ref3.checked,
      disabled = _ref3.disabled,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = null;
  var inputSource = null;
  var styles = null;

  if (checked) {
    source = theme.reactackle.components.radio.label.checked;
    inputSource = theme.reactackle.components.radio.input.checked;
  } else {
    source = theme.reactackle.components.radio.label;
    inputSource = theme.reactackle.components.radio.input;
  }

  var inputDefault = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';', '    '], inputSource.backgroundColor, inputSource.borderColor, checked ? 'box-shadow:\n         inset 0 0 0 0.5px ' + inputSource.borderColor + ',\n         inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.knobOffsetSize) + '\n            ' + inputSource.knobOffsetColor + ';' : null);
  var inputHover = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';', '    '], inputSource.hover.backgroundColor, inputSource.hover.borderColor, checked ? 'box-shadow:\n         inset 0 0 0 0.5px ' + inputSource.hover.borderColor + ',\n         inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.hover.knobOffsetSize) + '\n            ' + inputSource.hover.knobOffsetColor + ';' : null);
  var inputFocus = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';', '    '], inputSource.focus.backgroundColor, inputSource.focus.borderColor, checked ? 'box-shadow:\n           inset 0 0 0 0.5px ' + inputSource.focus.borderColor + ',\n           inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.focus.knobOffsetSize) + '\n              ' + inputSource.focus.knobOffsetColor + ';' : null);
  var inputDisabled = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';cursor:default;', '  '], inputSource.disabled.backgroundColor, inputSource.disabled.borderColor, checked ? 'box-shadow:\n           inset 0 0 0 0.5px ' + inputSource.disabled.borderColor + ',\n           inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.disabled.knobOffsetSize) + '\n              ' + inputSource.disabled.knobOffsetColor + ';' : null);

  if (!disabled) {
    styles = (0, _styledComponents.css)(['color:', ';&:before{', '}&:hover,&:focus:hover,input[type=\'radio\']:focus + &:hover{color:', ';&:before{', '}}&:focus,input[type=\'radio\']:focus + &{color:', ';&:before{', '}}'], source.fontColor, inputDefault, source.hover.fontColor, inputHover, source.focus.fontColor, inputFocus);
  } else {
    styles = (0, _styledComponents.css)(['         &,&:hover,&:focus,input[type=\'radio\']:disabled:focus + &{color:', ';cursor:default;&:before{', '}}'], source.disabled.fontColor, inputDisabled);
  }

  return styles;
};
/** STYLES */


var RadioLabelStyled = exports.RadioLabelStyled = _styledComponents2.default.label.withConfig({
  displayName: 'RadioLabelStyled'
})(['position:relative;cursor:pointer;display:block;user-select:none;', ' ', ' ', ';&:before{content:\'\';display:block;position:absolute;left:0;', ' ', ';}'], labelBase, labelStateProps, (0, _reactackleCore.transition)('color'), inputBase, (0, _reactackleCore.transition)('color, background-color, border-color'));

RadioLabelStyled.propTypes = propTypes;
RadioLabelStyled.defaultProps = defaultProps;
RadioLabelStyled.displayName = 'RadioLabelStyled';